import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center p-4">
      <div className="bg-surface-container-high p-12 border border-white/10 max-w-2xl w-full text-center relative overflow-hidden group">
        <div className="absolute inset-0 bg-secondary/5 group-hover:bg-secondary/10 transition-colors" />
        
        <span className="material-symbols-outlined text-8xl text-secondary mb-6 relative z-10">
          location_off
        </span>
        
        <h1 className="text-6xl font-headline font-black uppercase italic mb-4 text-white relative z-10 tracking-tighter">
          404 Not Found
        </h1>
        
        <p className="font-label text-on-surface-variant mb-12 uppercase tracking-[0.2em] relative z-10">
          The requested signal could not be located in the database.
        </p>
        
        <Link
          to="/hn"
          className="inline-block px-8 py-4 bg-secondary text-on-secondary font-black uppercase tracking-widest hover:bg-white transition-colors relative z-10"
        >
          Return to Feed
        </Link>
      </div>
    </div>
  );
}
